import { AdminEOPolicyPage } from './index'
import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(
    AdminEOPolicyPage,
    '/admin-eo-policy',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['agency-owner', 'internal-admin', 'internal-staff', 'system-admin']),
    ],
    {
      name: 'E&O Policy Administration',
    }
  ),
]
